function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import { useFallbackStorageValue } from "~/lib/hooks";
import { SignUpMatrixV1LocalStorageKey, SignUpNewsletterItemV1LocalStorageKey } from "./consts";
import { SocialType } from "./enums";
import { useSocialLogin } from "./hooks";
var EmailIcon = function EmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 7.548v9.1c0 1.15-.99 2.09-2.2 2.09H2.2c-1.21 0-2.2-.94-2.2-2.09l.007-9.1 11.026 4.635L22 7.548zM19.8.738c1.21 0 2.2.94 2.2 2.089v3.332l-10.968 4.669L.008 6.16l.003-3.333c0-1.1.896-2.007 2.033-2.084L2.2.738z",
    fill: "#AAA"
  }));
};
EmailIcon.defaultProps = {
  width: "22",
  height: "19",
  viewBox: "0 0 22 19",
  xmlns: "http://www.w3.org/2000/svg"
};
var FacebookIcon = function FacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.805C22 5.692 17.075.738 11 .738S0 5.692 0 11.805c0 5.524 4.023 10.102 9.281 10.933v-7.734H6.488v-3.2h2.793V9.367c0-2.773 1.642-4.305 4.155-4.305 1.204 0 2.462.216 2.462.216V8h-1.387c-1.366 0-1.792.853-1.792 1.729v2.076h3.05l-.487 3.199h-2.563v7.734c5.258-.83 9.281-5.41 9.281-10.933",
    fill: "#1977F2",
    fillRule: "evenodd"
  }));
};
FacebookIcon.defaultProps = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  xmlns: "http://www.w3.org/2000/svg"
};
var GoogleIcon = function GoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.168 11.783c0-.766-.069-1.502-.196-2.21H10.8v4.179h5.812a4.968 4.968 0 0 1-2.155 3.26v2.709h3.49c2.043-1.88 3.221-4.649 3.221-7.938z",
    fill: "#4285F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 22.338c2.916 0 5.36-.968 7.148-2.617l-3.49-2.71c-.968.648-2.205 1.031-3.658 1.031-2.813 0-5.194-1.9-6.043-4.452H1.149v2.798a10.796 10.796 0 0 0 9.651 5.95z",
    fill: "#34A853",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.757 13.59a6.492 6.492 0 0 1-.339-2.052c0-.712.123-1.404.339-2.052V6.687H1.149A10.796 10.796 0 0 0 0 11.537c0 1.743.417 3.393 1.149 4.85l3.608-2.797z",
    fill: "#FBBC05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5.033c1.586 0 3.01.545 4.129 1.615l3.097-3.098C16.156 1.808 13.711.738 10.8.738c-4.222 0-7.874 2.42-9.651 5.95l3.608 2.798c.85-2.553 3.23-4.453 6.043-4.453z",
    fill: "#EA4335",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .738h21.6v21.6H0z"
  })));
};
GoogleIcon.defaultProps = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  xmlns: "http://www.w3.org/2000/svg"
};
import { Container, IconContainer } from "./styles";
export const SocialButtons = ({
  isAgreedReceiveMarketing,
  onEmailClick,
  ...props
}) => {
  const {
    campaignName,
    dataMatrix,
    newsletterItems,
    queryParametersForSocialButtons,
    variant
  } = useNewsletterContext();
  const {
    getSocialLoginUrl
  } = useSocialLogin();
  const {
    handleRoutePush,
    handleTrackGA4
  } = useSdkContext();
  const {
    set: setSubscriptionNewsletterItem
  } = useFallbackStorageValue(SignUpNewsletterItemV1LocalStorageKey);
  const {
    set: setSignUpMatrixV1LocalStorageKey
  } = useFallbackStorageValue(SignUpMatrixV1LocalStorageKey);
  const handleSocialButtonClick = socialType => {
    var _newsletterItems$0$na, _newsletterItems$0$na2;
    // Not setting these in querystring because of character limited in url
    setSubscriptionNewsletterItem(newsletterItems);
    setSignUpMatrixV1LocalStorageKey(dataMatrix);
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        method: socialType,
        newsletter_name: (_newsletterItems$0$na = newsletterItems[0].name) !== null && _newsletterItems$0$na !== void 0 ? _newsletterItems$0$na : "",
        trigger_point: getTriggerPoint(variant)
      },
      subcategory: "sign_up"
    });
    const newsletterItemIds = newsletterItems.filter(item => item.entityId).map(item => item.entityId);
    void handleRoutePush(getSocialLoginUrl(socialType, {
      campaignName,
      newsletterIds: newsletterItemIds,
      newsletterName: (_newsletterItems$0$na2 = newsletterItems[0].name) !== null && _newsletterItems$0$na2 !== void 0 ? _newsletterItems$0$na2 : "",
      subscription: "true",
      triggerPoint: getTriggerPoint(variant),
      variant
    }, isAgreedReceiveMarketing), {
      query: queryParametersForSocialButtons
    });
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "social-buttons"
  }), /*#__PURE__*/React.createElement(IconContainer, {
    onClick: () => handleSocialButtonClick(SocialType.Facebook)
  }, /*#__PURE__*/React.createElement(FacebookIcon, {
    height: "100%",
    width: "22"
  })), /*#__PURE__*/React.createElement(IconContainer, {
    onClick: () => handleSocialButtonClick(SocialType.Google)
  }, /*#__PURE__*/React.createElement(GoogleIcon, {
    height: "100%",
    width: "22"
  })), /*#__PURE__*/React.createElement(IconContainer, {
    onClick: onEmailClick
  }, /*#__PURE__*/React.createElement(EmailIcon, {
    height: "100%",
    width: "22"
  })));
};
SocialButtons.displayName = "SocialButtons";